import React from "react";
import "./Aboutme.css";
import Aboutimage from "../Assets/Aboutimage.png";
import cvFile from "../Assets/Shohruh Karimqulov CV .pdf";


function Aboutme() {
    
    return (
<section id="about-me" className="about-me" >
  <div class="about-me-container">
    <h2 className="about-me-title">About me</h2>
    <div class="about-me-content">
      <img class="about-me-image" src={Aboutimage} alt="Aboutimage" />
    <div className="rightinfo">
      <h2 class="about-me-text">I have over 5 years of experience in design, focusing on creating UX/UI solutions for SaaS platforms, E-Commerce Websites, Mobile Apps, LMS, CRM, AI Platforms, and more. I continually learn and approach every project with care and responsibility, delivering designs that make an impactful.</h2>
      <text-button class="download-cv-btn">
        <a href={cvFile} download="Shohruh Karimqulov CV.pdf" class="btn-icon">  <icon>📄</icon> Learn more about me in my CV </a>
      </text-button>
      </div>
    </div>
  </div>
</section>
    );
}

export default Aboutme
